// extracted by mini-css-extract-plugin
export default {"container":"components-TZ-_TZ-module_container","text":"components-TZ-_TZ-module_text"};